import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import React, { useState } from "react";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const DataTable = ({ data, setSelectedId, handleShow }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Categories Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [["ID", "Name", "Similar_Terms"]],
      body: data.map((item) => [item.id, item.name, item.similar_terms]),
    });
    doc.save("categories_table.pdf");
  };

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {["id", "name", "driver", "priority", "daily_limit"].map((column) => (
                <TableCell
                  key={column}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                >
                  <TableSortLabel
                    active={orderBy === column}
                    direction={orderBy === column ? order : "asc"}
                    onClick={() => handleSort(column)}
                  >
                    {column}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">{item?.name}</TableCell>
                <TableCell align="center">{item?.driver}</TableCell>
                <TableCell align="center">{item?.priority}</TableCell>
                <TableCell align="center">{item?.daily_limit}</TableCell>
                <TableCell align="center">
                  <div className="flex gap-x-10 text-lg items-center justify-center">
                    <Link
                      to={`/EmailProviders/Edit/${item?.id}`}
                      color="inherit"
                      underline="none"
                    >
                      <FaPencilAlt className="text-[#6c757d]" />
                    </Link>
                    <FaTrashAlt
                      onClick={() => {
                        setSelectedId(item?.id);
                        handleShow();
                      }}
                      className="text-[#d9534f] cursor-pointer"
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
